<div id="contenedor_carga">
    <div id="cargando"></div>
  </div>
